export function format(date) { 
    let year = date.getFullYear();
    let month = date.getMonth() + 1< 10 ? '0' + (date.getMonth() + 1) : '' + date.getMonth();
    let day = date.getDate() < 10 ? '0' + date.getDate() : '' + date.getDate();
    let hour = date.getHours() < 10 ? '0' + date.getHours() : '' + date.getHours();
    let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : '' + date.getMinutes();
    let second = date.getSeconds() < 10 ? '0' + date.getSeconds() : '' + date.getSeconds();

    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + second;
}       


// WEBPACK FOOTER //
// ./src/common/utils/date.js